import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  uploadTIDFile,
  getTIDData,
} from "../../store/actions/fileUploadActions";
import DataTable from "../../components/Table";

const EDC_Matrix = ({ dashboardData, uploadTIDFile, getTIDData }) => {
  const [state, setState] = useState({
    pageNo: 1,
    size: 100,
    searchString: "",
  });

  const fetchData = useCallback(() => {
    getTIDData(state.pageNo, state.size, state.searchString);
  }, [state.pageNo, state.size, state.searchString, getTIDData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFileUpload = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    uploadTIDFile(formData, fetchData);
  };

  const triggerUploadCSV = () => {
    const uploadInput = document.getElementById("edc-csv-upload");
    if (uploadInput) {
      uploadInput.click();
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setState((prev) => ({ ...prev, searchString: value }));
  };

  const searchBranchData = () => {
    if (state.pageNo === 1) {
      fetchData();
    } else {
      setState((prev) => ({ ...prev, pageNo: 1 }));
    }
  };

  const nextPage = () => {
    if (state.pageNo < (dashboardData.totalPages || 1)) {
      setState((prev) => ({ ...prev, pageNo: prev.pageNo + 1 }));
    }
  };

  const prevPage = () => {
    if (state.pageNo > 1) {
      setState((prev) => ({ ...prev, pageNo: prev.pageNo - 1 }));
    }
  };

  const totalPages = dashboardData.totalPages || 1;

  return (
    <>
      <div className="operations-page__panel operations-page__panel--compact">
        <div className="operations-page__controls-row">
          <button
            type="button"
            className="operations-page__btn operations-page__btn--primary"
            onClick={triggerUploadCSV}
          >
            Upload TID file
          </button>
          <input
            id="edc-search"
            onChange={handleSearchChange}
            value={state.searchString}
            className="operations-page__input operations-page__input--search"
            type="text"
            placeholder="Search branch code data"
            name="searchString"
            aria-label="Search branch code data"
          />
          <button
            type="button"
            className="operations-page__btn operations-page__btn--primary"
            onClick={searchBranchData}
          >
            Search
          </button>
          <input
            id="edc-csv-upload"
            className="operations-page__file-input"
            type="file"
            accept=".xls, .xlsx"
            onChange={(e) => {
              if (e.target.files?.length) {
                handleFileUpload(e.target.files[0]);
                e.target.value = null;
              }
            }}
          />
        </div>
      </div>

      {dashboardData.ifscData && (
        <div className="proposal-dashboard__table-section operations-page__table-section">
          <DataTable
            cellHeaders={["Branch Code", "TID"]}
            data={dashboardData.ifscData}
            keys={["branch_code", "tid"]}
            fileName="TID Data"
            addSerialNo={true}
            showExcelDownload={true}
            PerPageApiData={false}
            paginationItems={dashboardData.ifscData}
            alwaysShown={false}
            tableToolbarExtra={
              <div className="operations-page__api-pagination">
                <span className="operations-page__page-info">
                  Page {state.pageNo} of {totalPages}
                </span>
                <button
                  type="button"
                  className="operations-page__btn operations-page__btn--secondary operations-page__page-btn"
                  onClick={prevPage}
                  disabled={state.pageNo <= 1}
                >
                  Prev
                </button>
                <button
                  type="button"
                  className="operations-page__btn operations-page__btn--secondary operations-page__page-btn"
                  onClick={nextPage}
                  disabled={state.pageNo >= totalPages}
                >
                  Next
                </button>
              </div>
            }
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  dashboardData: state.dashboardData,
});

export default connect(mapStateToProps, {
  uploadTIDFile,
  getTIDData,
})(EDC_Matrix);
